/**
 * Validate an admin-entered per-kg rate.
 *
 * Mirrors the backend's `parsePriceInput` (admin.controller) so the admin sees
 * the problem before the round trip, and the two can't disagree about what a
 * valid rate is. Decimals are allowed - service_items.price is DECIMAL(10,2).
 */
export type RateValidation = { ok: true; value: number } | { ok: false; message: string }

export const validateRate = (raw: string): RateValidation => {
  const trimmed = String(raw ?? '').trim()
  if (!trimmed) return { ok: false, message: 'Enter a rate.' }
  const parsed = Number(trimmed)
  if (!Number.isFinite(parsed)) return { ok: false, message: 'Rate must be a number.' }
  if (parsed < 0) return { ok: false, message: 'Rate cannot be negative.' }
  if (parsed > 1000000) return { ok: false, message: 'Rate is unrealistically high.' }
  return { ok: true, value: Math.round(parsed * 100) / 100 }
}
